import Box from 'components/shared/Box'
import loader from 'assets/icons/loader.png'
import { LoaderImg } from './styles'
import { BoxProps } from 'components/shared/Box/index'
import { ResponsiveSize } from 'styles/types'

interface LoaderProps extends BoxProps {
    src?: string
    size?: ResponsiveSize
}

const Loader = (props: LoaderProps) => (
    <Box {...props}>
        <LoaderImg src={props.src ?? loader} alt="loader" size={props.size} />
    </Box>
)

export default Loader
